// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1);
}

.game-tags--compact {
  gap: 4px;
}

.game-tag {
  display: inline-block;
  padding: 3px 10px;
  border-radius: var(--radius-full);
  font-family: var(--font-body);
  font-size: var(--font-size-body-sm);
  background: var(--color-wood-600);
  color: var(--color-parchment-100);
  border: 1px solid var(--color-wood-700);
  line-height: 1.4;
}

.game-tag--filter {
  cursor: pointer;
  transition: all var(--transition-fast);
  user-select: none;
  padding: var(--space-1) var(--space-3);
  font-size: var(--font-size-body-sm);
  border-width: 2px;
}

.game-tag--filter:hover {
  background: var(--color-wood-700);
  border-color: var(--color-parchment-300);
  color: var(--color-parchment-100);
}

.game-tag--active {
  background: var(--color-fire-500);
  color: var(--color-parchment-100);
  border-color: var(--color-fire-600);
}

.game-tag--active:hover {
  background: var(--color-fire-600);
  border-color: var(--color-fire-700);
}

.game-tags--compact .game-tag {
  font-size: var(--font-size-caption);
  padding: 1px 6px;
}

.game-tags--compact .game-tag--filter {
  padding: 2px 8px;
  cursor: pointer;
}

.game-tags--compact .game-tag--filter:hover {
  background: var(--color-fire-500);
  border-color: var(--color-fire-600);
  color: var(--color-parchment-100);
}

.game-tags--collapsed {
  flex-wrap: nowrap;
  overflow: hidden;
}

.game-tags__more {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: var(--radius-full);
  font-family: var(--font-body);
  font-size: var(--font-size-caption);
  font-weight: 700;
  background: var(--color-fire-500);
  color: var(--color-parchment-100);
  border: 1px solid var(--color-fire-600);
  cursor: pointer;
  line-height: 1.4;
  transition: background var(--transition-fast);
  white-space: nowrap;
}

.game-tags__more:hover {
  background: var(--color-fire-600);
}
`, "",{"version":3,"sources":["webpack://./src/features/games/GameTagsList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iCAAiC;EACjC,6BAA6B;EAC7B,mCAAmC;EACnC,iCAAiC;EACjC,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,iBAAiB;EACjB,sCAAsC;EACtC,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,6BAA6B;EAC7B,mCAAmC;EACnC,gBAAgB;EAChB,iCAAiC;EACjC,iCAAiC;EACjC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":[".game-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-1);\n}\n\n.game-tags--compact {\n  gap: 4px;\n}\n\n.game-tag {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: var(--radius-full);\n  font-family: var(--font-body);\n  font-size: var(--font-size-body-sm);\n  background: var(--color-wood-600);\n  color: var(--color-parchment-100);\n  border: 1px solid var(--color-wood-700);\n  line-height: 1.4;\n}\n\n.game-tag--filter {\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  user-select: none;\n  padding: var(--space-1) var(--space-3);\n  font-size: var(--font-size-body-sm);\n  border-width: 2px;\n}\n\n.game-tag--filter:hover {\n  background: var(--color-wood-700);\n  border-color: var(--color-parchment-300);\n  color: var(--color-parchment-100);\n}\n\n.game-tag--active {\n  background: var(--color-fire-500);\n  color: var(--color-parchment-100);\n  border-color: var(--color-fire-600);\n}\n\n.game-tag--active:hover {\n  background: var(--color-fire-600);\n  border-color: var(--color-fire-700);\n}\n\n.game-tags--compact .game-tag {\n  font-size: var(--font-size-caption);\n  padding: 1px 6px;\n}\n\n.game-tags--compact .game-tag--filter {\n  padding: 2px 8px;\n  cursor: pointer;\n}\n\n.game-tags--compact .game-tag--filter:hover {\n  background: var(--color-fire-500);\n  border-color: var(--color-fire-600);\n  color: var(--color-parchment-100);\n}\n\n.game-tags--collapsed {\n  flex-wrap: nowrap;\n  overflow: hidden;\n}\n\n.game-tags__more {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  padding: 2px 8px;\n  border-radius: var(--radius-full);\n  font-family: var(--font-body);\n  font-size: var(--font-size-caption);\n  font-weight: 700;\n  background: var(--color-fire-500);\n  color: var(--color-parchment-100);\n  border: 1px solid var(--color-fire-600);\n  cursor: pointer;\n  line-height: 1.4;\n  transition: background var(--transition-fast);\n  white-space: nowrap;\n}\n\n.game-tags__more:hover {\n  background: var(--color-fire-600);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
